import { Anchor } from "@aircall/ds";
import { useTranslation } from "react-i18next";
import TranscriptionBadAccousticsSvg from "@/assets/transcription_bad_accoustics.svg?react";
import { TranscriptionMessageTitle } from "../../../TranscriptionMessageTitle/TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../../../TranscriptionSubTitle/TranscriptionSubTitle";

export function TranscriptionBadAccoustics() {
  const { t } = useTranslation();

  return (
    <>
      <TranscriptionBadAccousticsSvg />
      <TranscriptionMessageTitle>
        {t("no_transcript.bad_accoustic_title")}
      </TranscriptionMessageTitle>
      <TranscriptionSubTitle>
        {t("no_transcript.bad_accoustic_description")}
      </TranscriptionSubTitle>
      <Anchor
        target="_blank"
        href={t("no_transcript.bad_accoustic_link")}
        className="text-xs font-medium"
      >
        {t("learn_more")}
      </Anchor>
    </>
  );
}
